import React, { useEffect, useRef, useState } from "react";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import dayjs from "dayjs";
import DefaultHeading from '../../components/heading/DefaultHeading';
import "./CreateNewPrimaryOrder.css";
import { useDispatch } from "react-redux";
import NewDiscountModalPrimary from "../claimsNew/modals/NewDiscountModalPrimary";
import { useNavigate, useLocation,useParams  } from 'react-router-dom';
import { Loader } from "../../components/loader/Loader";
import { ReactComponent as NoProducts } from "../../assets/image/svg/noProductsFound.svg";
import { Grid, Pagination } from '@mui/material';
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import {
    GenericModal,
    getGenericModalProps,
    initialGenericModalProps,
    mergeProductsWithOmsRows,
    prepareSaveChangesReqBody,
    transformValidateResponse,
} from "../viewOrder/ViewOrderUtils";
import {  createQuery, getOutletDetails,getPieceFilterMapping, getValidateRequestBody, prepareOrderReqBody,  getFilterOptionsUnique, updateMultiQtyInCart } from "../createSecondaryOrder/CreateSecondaryOrderService";
import { OrderType } from "../../types/types";
import Search from "../../components/dms_common/Search";
import { clearAllDataFromLocalDb, getDataFromLocalDb, insertDataIntoLocalDB } from "../../services/dbService";
import { Cart, Catalogue, CartProduct, ProductUI } from "../createSecondaryOrder/models";
import { createCatalogue, createPricingForArsSkus } from "../../services/catalogueService";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import CartSummaryFooter from "../../components/dms_common/CartSummaryFooter";
import{
updateQuantityInCart
} from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import CatalogueProductCardPrimary from "./CatalogueProductCardPrimary";
import { getConfigData } from "../../services/configurationService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "../../services/networkService";
import { analytics, logLoadTrace } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { getSinglePrimaryOrder, updateOrder } from "../../services/manageOrderService";
import CatalogueFiltersNew from "../../components/dms_common/CatalogueFiltersNew";
import { ARSBatchMap, ARSPricingMap } from "../viewPrimaryOrder/ViewPrimaryOrder";
import { ReactComponent as ListViewToggle } from "../../assets/image/svg/listViewToggle.svg";
import { ReactComponent as GridViewToggle } from "../../assets/image/svg/gridViewToggle.svg";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { safeStringify } from "../../components/dms_common/DmsUtils";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import FormHeader from "../../components/dms_common/FormHeader";
const CreateNewPrimaryOrder = () => {
    const navigate = useNavigate();
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    const query = useQuery();
    sessionStorage.removeItem("sessionStorageDmsFilters")
    const outletId = query.get("outletId") || "self"; // Use query param or default to "self"
    const [loading, setLoading] = useState<boolean>(false);
    const [productLoading, setProductLoading] = useState<boolean>(false);
    const [totalQuantity, setTotalQuantity] = useState<number>(0);
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [cart, setCart] = useState<Cart>({});
    const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
    const [productUIList, setProductUIList] = useState<ProductUI[]>([]);
    const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
    const [navigateBackOnClose, setNavigateBackOnClose] = useState<boolean>(false);
    const [searchedValue, setSearchedValue] = useState<string>("");    
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [selectedSku, setSelectedSku] = useState<any>({});
    const [totalNumberOfProducts, setTotalNumberOfProducts] = useState(0);
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const createPrimaryOrderUom = ConfigDictionary.createPrimaryOrderUom ?? ""
    const productsPerPage = ConfigDictionary.otherUnitLabelPrimary ? 15 : 18;  
    const [customerBillingInfo, setCustomerBillingInfo] = useState<Record<string, any>>({});
    const [isStockDataLoaded, setIsStockDataLoaded] = useState(false);
    
    const [filterOptions, setFilterOptions] = useState<Record<string, string[]>>({});
    const [newFiltersConfig, setNewFiltersConfig] = useState<string[]>([]);
    const [initialCatalogue, setInitialCatalogue] = useState<Catalogue[]>([]);
    const [selectedFilters, setSelectedFilters] = useState<Record<string, string>>(()=>{
       const initialFilters: Record<string, string> = {};
       newFiltersConfig.forEach(filter => {
       initialFilters[filter] = "ALL";
    });
    return initialFilters;});
    const  [showListView, setShowListView] = useState(true);
    const [catalogueCreated, setCatalogueCreated] = useState<boolean>(false);

    const { orderId } = useParams();

    const disableStockCheck = useRef<boolean>(false);
    const disableSchemeCheckPrimary = useRef<boolean>(true);
    const disableSchemeCheckPrimaryOMS = useRef<boolean>(true);

    const previousSearchRef = useRef<string>("");
    const dispatch = useDispatch();
    const handleClickViewSkuDetails = (product: ProductUI) => {
        setSelectedSku(product);
        dispatch(setDiscountModalState(true));
      };
      const location = useLocation();
      const state = location.state as
        | {
            arsMap?: ARSBatchMap;
            arsPricingMap?: ARSPricingMap;
            edit?: boolean;
            showListView?: boolean;
            isPrimaryOMS?: boolean;
            addMorePrimaryOmsRowsData?:any;
          }
        | undefined;

    const isPrimaryOMS = state?.isPrimaryOMS ?? false;
    const addMorePrimaryOmsRowsData = state?.addMorePrimaryOmsRowsData ?? []

  const { reStock, skuCodes } = location.state || {};
  const populateCart = async (data: any) => {
    if(isPrimaryOMS )  return ;

    const invalidItems: any[] = [];

    data?.orderDetails?.forEach((item: any) => {
      const { batchCode, caseQuantity, pieceQuantity, otherUnitQuantity } = item;
      if (!batchCode || (!caseQuantity && !pieceQuantity && !otherUnitQuantity)) {
        invalidItems.push(item); 
      }
      updateMultiQtyInCart(
        batchCode,
        {
          caseQuantity: caseQuantity,
          otherUnitQuantity: otherUnitQuantity,
          pieceQuantity: pieceQuantity,
        },
        { outletCode: "self" },
        initialCatalogue,
        setCart
      );
    });
    if (invalidItems.length) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Invalid Items in populateCart - CreateNewPrimaryOrder.tsx",
        `Found ${invalidItems.length} item(s) with missing batchCode or quantity.`,
        safeStringify(invalidItems)
      )
    }
  };

  const getSkuData = () => {
    return {
      productUI: selectedSku,
      orderDetails: [
        {
          extendedAttributes: { blobKey: selectedSku?.imageUrl },
          skuDescription: selectedSku?.name,
          batchCode: selectedSku?.batchCode,
          caseQuantity: selectedSku?.availableCaseQty,
          pieceQuantity: selectedSku?.availablePieceQty,
          otherUnitQuantity: selectedSku?.availableOtherQty,
          discountInfo: selectedSku?.schemes?.map((scheme: any) => {
            return { ...scheme, discountInfo: scheme?.schemeDescription };
          }),
          pieceSize: getPieceFilterMapping(selectedSku?.pieceSize?.toString()),
          mrp: selectedSku?.mrp,
          productInfo: { skuDescription: selectedSku?.name ?? "" }
        },
      ],
    };
  };



    const handleCheckout = () => {
        if ((Object.keys(cart?.[customerBillingInfo?.outletCode]?.productsMap ?? {}).length) > 0) {
            setCart((prevCart) => {
                const updatedCart = { ...prevCart };
                if (updatedCart[customerBillingInfo?.outletCode]) {
                    updatedCart[customerBillingInfo?.outletCode] = {
                        productsMap: updatedCart[customerBillingInfo?.outletCode].productsMap,
                        customer: customerBillingInfo,
                    };
                }
                insertDataIntoLocalDB("Cart", [{ "id": 1, "data": updatedCart }]);
                return updatedCart;
            });
            navigate(`checkout?outletId=${customerBillingInfo?.outletCode}&salesType=primary`, {
                state: {
                    showListView: showListView
                }
            });
        }
        else {

        const updatedGenericModalProps = getGenericModalProps(
            `positive`,
            `Add items to the cart for proceeding further.`,
            `Continue`,
            ``,
            () => setGenericModalProps(initialGenericModalProps)
            );
            setGenericModalProps(updatedGenericModalProps);
        }
    }

  const fetchRequiredConfigs = async () => {
    try {
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res6 = await getConfigData("dms_configuration", "disableSchemeCheckPrimaryOMS");
      const res7 = await getConfigData("dms_configuration","disableSchemeCheckPrimary");
      const res5 = await getConfigData("order_configuration","filterProductAttributes")
      setNewFiltersConfig(res5[0]?.configValue ?? []);
      disableStockCheck.current = res3[0]?.configValue ?? false;
      disableSchemeCheckPrimaryOMS.current = res6[0]?.configValue ?? true;
      disableSchemeCheckPrimary.current = res7[0]?.configValue ?? true;
    } catch (e) {
      console.error("Error while fetching configs", e);
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching Configs in fetchRequiredConfigs - CreateNewPrimaryOrder.tsx",
        "Failed to fetch configuration data, which may affect UI functionality.",
        safeStringify(e)
     );
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  };
    
    useEffect(() => {
      const getAndSetStockData = async () => {
        if(!isStockDataLoaded) {
            try {
                await setRealTimeStockDataInDb("", createPrimaryOrderUom);
                setIsStockDataLoaded(true);
            } catch (error) {
              await sendSlackAlert(
                SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
                "Error Loading Stock Data in getAndSetStockData - CreateNewPrimaryOrder.tsx",
                "Failed to load stock data",
                safeStringify(error)
              );
                console.error(error);
            }
        }
      }

      logLoadTrace(getAndSetStockData,"create_primary_order_stock_load_time");
    }, [isStockDataLoaded])

    useEffect(() => {
        const getAndSetData = async () => {
            setLoading(true);
            if (!isStockDataLoaded) return;
            try {
              if (state?.showListView !== undefined) {
                    setShowListView(state.showListView);
                }
                await clearAllDataFromLocalDb("PrimaryCatalogue");

                // this runs for add more functionality
                if (orderId) {
                    await getOrderDetails(orderId);
                    if(isPrimaryOMS) {
                      await resetCart()
                    }
                    // setIsOrderDataLoaded(true); // Flag that orderData is ready
                  }  else if(!outletId) {
                    resetCart()
                  }
                const orderFulfillmentConfigPrimary = ConfigDictionary?.orderFulfillmentTimePrimary ? ConfigDictionary?.orderFulfillmentTimePrimary  : 2
                const getSchemes: boolean = (!disableSchemeCheckPrimary.current) || (!disableSchemeCheckPrimaryOMS.current && isPrimaryOMS);
                const catalogue = await createCatalogue(
                    OrderType.PRIMARY,
                    orderId ? outletId : JSON.parse(localStorage.authContext)?.user?.loginId,
                    getSchemes,
                    undefined,
                    undefined,
                    undefined,
                    true,
                );
                const responseFilterOptions = getFilterOptionsUnique(catalogue,newFiltersConfig as (keyof Catalogue)[]);
                if (responseFilterOptions) {
                  setFilterOptions(responseFilterOptions);
                }else {
                  await sendSlackAlert(
                      SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
                      "Missing Filter Options in getAndSetData - CreateNewPrimaryOrder.tsx",
                      "Filter options were not generated, which may affect product filtering in the UI.",
                      safeStringify({ catalogue, newFiltersConfig, orderId, outletId })
                  );
              }
                 const responseOutletDetails = await getOutletDetails(JSON.parse(localStorage.authContext)?.user?.loginId);
                const outletsList = responseOutletDetails.filter(
                (outlet) => outlet.outletCode === JSON.parse(localStorage.authContext)?.user?.loginId
                );
                const customer = {
                    outletCode : "self",
                    billDate : dayjs().format('DD/MM/YY'),
                    deliveryDate: dayjs().add(orderFulfillmentConfigPrimary , 'day').format('DD/MM/YY'),
                    paymentMethod:outletsList?.[0]?.extendedAttributes?.preferredPaymentMode ?? "",
                    shippingAddress : outletsList?.[0]?.address ?? "",
                    differentShippingAddress : outletsList?.[0]?.extendedAttributes?.shipTo?.address ?? ""
                }
                setCustomerBillingInfo(customer)
                setCatalogueCreated(true)
                setLoading(false);
                await createProductUI("self");
            } catch (err: any) {
                setLoading(false);
                console.error(err);
                console.error("Error while refreshing the products list: ", err);
                await sendSlackAlert(
                  SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
                  "Error Setting Up Data in getAndSetData - CreateNewPrimaryOrder.tsx",
                  `Failed to set up catalogue or customer data: ${err.message}`,
                  safeStringify({ error: err, orderId, outletId })
              );
                if (err?.message === "pricing") {
                  setGenericModalProps(
                    getGenericModalProps("error", "⚠️  Unable to fetch pricing details. Please try again later.",
                      "Ok",
                      ``,
                      () => {
                        setGenericModalProps(initialGenericModalProps)
                      }
                    ));
                } else if (err?.message === "offers") {
                  setGenericModalProps(
                    getGenericModalProps("error", "⚠️  Unable to load offer details. Please refresh or try again.",
                      "Ok",
                      ``,
                      () => {
                        setGenericModalProps(initialGenericModalProps)
                      }
                    )
                  );
                } else {
                  setGenericModalProps(
                    getGenericModalProps("error", `⚠️  Unable to setup catalogue.`)
                  );
                }
            }
        }
        logLoadTrace(getAndSetData,"create_primary_order_page_load_time");
    }, [isStockDataLoaded]);

    useEffect(() => {
            createProductUI(customerBillingInfo?.outletCode);
    }, [searchedValue, selectedFilters, showListView]);

  useEffect(() => {
    
    if(!orderId) {
        logEvent(analytics, "primary_order_initiated", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId
        });
      }

    if(!outletId) resetCart();
    fetchRequiredConfigs();
  }, []);


    const updateSubsequentFilterOptions = (currentFilters: Record<string, string>, currentIndex: number) => {
      const allFilterTypes = newFiltersConfig;

      // Filter the catalogue based on selections up to and including the current filter
      const filtersUpToCurrent = Object.fromEntries(
          allFilterTypes
              .slice(0, currentIndex + 1)
              .map(key => [key, currentFilters[key] || "ALL"])
      );

      const filteredCatalogue = initialCatalogue.filter((item: Catalogue) => {
          return Object.entries(filtersUpToCurrent).every(([key, value]) => {
              if (value === "ALL") return true;
              return item[key as keyof Catalogue] === value;
          });
      });

      // Generate new filter options for all filters, but only update subsequent ones
      const newFilterOptions = getFilterOptionsUnique(filteredCatalogue, newFiltersConfig as (keyof Catalogue)[]);
      
      setFilterOptions((prevFilterOptions) => {
          const updatedOptions = { ...prevFilterOptions };
          // Only update options for filters below the current one
          for (let i = currentIndex + 1; i < allFilterTypes.length; i++) {
              updatedOptions[allFilterTypes[i]] = newFilterOptions[allFilterTypes[i]] || [];
          }
          return updatedOptions;
      });
    };

    const updateFilterSelection = (filterType: string, option: string, rowIndex: number) => {
      setCurrentPage(1);
  
      setSelectedFilters((prevSelectedOptions) => {
          const allFilterTypes = newFiltersConfig; // Array of filter types in order
          const currentIndex = allFilterTypes.indexOf(filterType);
          const newFilters = { ...prevSelectedOptions };
  
          // Set the current filter selection
          newFilters[filterType] = option;
  
          // If option is not "ALL", reset only subsequent filters to "ALL"
          if (option !== "ALL") {
              for (let i = currentIndex + 1; i < allFilterTypes.length; i++) {
                  newFilters[allFilterTypes[i]] = "ALL";
              }
          }
          // If option is "ALL", reset current and subsequent filters to "ALL"
          else {
              for (let i = currentIndex; i < allFilterTypes.length; i++) {
                  newFilters[allFilterTypes[i]] = "ALL";
              }
          }
  
          console.log("Updated filters:", newFilters);
  
          // Update filter options for subsequent filters only
          updateSubsequentFilterOptions(newFilters, currentIndex);
  
          return newFilters;
      });
    };
    

    function customSplit(s: string): string[] {
      if (s.includes(' ')) {
        s = s?.replace(/\s+/g, " ").trim(); // normalize spaces and trim ends
        return s.split(" ");
      } else {
        return [s];
      }
    }

    const handleChangePage = (event: React.ChangeEvent<unknown>, page: number) => {
        setCurrentPage(page);
    };

    useEffect(() => {  
        createProductUI(customerBillingInfo.outletCode);
    },[currentPage]);

    useEffect(() => {
      const setInitialFilters = () => {
          if (newFiltersConfig.length > 0 && Object.keys(selectedFilters).length === 0) {
              const initialFilters: Record<string, string> = {};
              newFiltersConfig.forEach(filter => {
                  initialFilters[filter] = "ALL";
              });
              setSelectedFilters(initialFilters);
          }
      };
  
      setInitialFilters();
    }, [newFiltersConfig, initialCatalogue, orderId]);

    useEffect(() => {
      const fetchInitialCatalogue = async () => {
        const responseCatalogueInitialSet = await getDataFromLocalDb(
          "PrimaryCatalogue",
          createQuery(undefined, {}),
          undefined,
          productsPerPage,
          true
        );
        const dbResult = await getDataFromLocalDb("Product");
        const products: any = dbResult?.data?.[0]?.data ?? {};
        let catalogue = responseCatalogueInitialSet?.data as Catalogue[];
        if(state?.arsPricingMap) {
          let arsCat = createPricingForArsSkus(state?.arsPricingMap, products);
          catalogue = [...catalogue, ...arsCat];
        }
       
        setInitialCatalogue(catalogue);
      };
      if (catalogueCreated) fetchInitialCatalogue();
    }, [catalogueCreated]);
    
    const createProductUI = async (customerID: any) => {
        if(orderId) {
          customerID = 'self';
        }
        setProductLoading(true);
        try {
            const responseCatalogueNew = {
              data: [] as any,
              total: 0
            };

            const isNewSearch = previousSearchRef.current !== searchedValue;

            // If text in search box is changed then, reset pageNo to 1
            let pageNo: number | undefined = isNewSearch ? 1 : currentPage;
            if (showListView) {
                pageNo = undefined; // Fetch all products for list view
            }
            if(isNewSearch){setCurrentPage(1)}

            if (!searchedValue) {
              const query = createQuery(searchedValue, selectedFilters);
              let responseCatalogue = await getDataFromLocalDb('PrimaryCatalogue', query);
              if(state?.arsPricingMap) {
                const dbResult = await getDataFromLocalDb("Product");
                const products: any = dbResult?.data?.[0]?.data ?? {};
                let arsCat = createPricingForArsSkus(state?.arsPricingMap, products);
                responseCatalogue.data = [...responseCatalogue.data, ...arsCat];
                responseCatalogue.total = responseCatalogue.data.length;
              }
              responseCatalogueNew.data = responseCatalogue.data;
              responseCatalogueNew.total = responseCatalogue.total;
            } 
            else {
              const newSearchedValues = Array.from(customSplit(searchedValue).values());;
              const allResponses: { id: string | number }[][] = [];

              //For each search value query the index.db
              for (const value of newSearchedValues) {
                const query = createQuery(value, selectedFilters);
                const responseCatalogue = await getDataFromLocalDb('PrimaryCatalogue', query);
                if(state?.arsPricingMap) {
                  const dbResult = await getDataFromLocalDb("Product");
                  const products: any = dbResult?.data?.[0]?.data ?? {};
                  let arsCat = createPricingForArsSkus(state?.arsPricingMap, products);
                  responseCatalogue.data = [...responseCatalogue.data, ...arsCat];
                  responseCatalogue.total = responseCatalogue.data.length;
                }
                allResponses.push(responseCatalogue.data);
              }

              // Step 1: Build a Map of ID => count and store item
              const idCountMap = new Map<string | number, { count: number; item: any }>();

              for (const responseData of allResponses) {
                for (const item of responseData) {
                  const entry = idCountMap.get(item.id);
                  if (entry) {
                    entry.count++;
                  } else {
                    idCountMap.set(item.id, { count: 1, item });
                  }
                }
              }

              // Step 2: Keep only items that appear in all responses
              const requiredCount = allResponses.length;
              responseCatalogueNew.data = Array.from(idCountMap.values())
                .filter(entry => entry.count === requiredCount)
                .map(entry => entry.item);
              responseCatalogueNew.total = responseCatalogueNew?.data?.length;
            }

            if (pageNo !== undefined && productsPerPage !== undefined && !showListView) {
            const skip = (pageNo - 1) * productsPerPage;
            responseCatalogueNew.data = responseCatalogueNew.data.slice(skip, skip + productsPerPage);
            }

            const responseCart = await getDataFromLocalDb('Cart');

            setTotalNumberOfProducts(responseCatalogueNew?.total);
            setCatalogue(responseCatalogueNew?.data);
            if(!orderId) {
              setCart(responseCart?.data?.[0]?.data);
            }
            
            let amount = 0;
            let quantity = 0;
            previousSearchRef.current = searchedValue;
            
            const productUi: ProductUI[] = responseCatalogueNew?.data?.map((catalogueItem: Catalogue) => {
                const cartItem: CartProduct = responseCart?.data?.[0]?.data?.[customerID]?.productsMap[catalogueItem?.batchCode];
                const product: ProductUI = {
                    isFavourite: catalogueItem?.isFavourite,
                    isRecommended: catalogueItem?.isRecommended,
                    name: catalogueItem?.name,
                    level: catalogueItem?.level,
                    description: catalogueItem?.description,
                    batchCode: catalogueItem?.batchCode,
                    marketSkuCode: catalogueItem?.marketSkuCode,
                    pieceQuantity: cartItem?.pieceQuantity || 0,
                    caseQuantity: cartItem?.caseQuantity || 0,
                    suggestedQuantity: catalogueItem?.suggestedQty,
                    suggestedOtherQuantity: catalogueItem?.suggestedOtherQty,
                    suggestedCaseQuantity: catalogueItem?.suggestedCaseQty,
                    priority: catalogueItem?.priority,
                    images: catalogueItem?.images,
                    imageUrl: catalogueItem?.imageUrl,
                    category: catalogueItem?.category,
                    brand: catalogueItem?.brand,
                    price: catalogueItem?.packPtr,
                    casePrice: catalogueItem?.casePtr,
                    amount: 0,
                    margin: 0,
                    netPtr: 0,
                    maxDiscount: 0,
                    volume: catalogueItem?.pieceSize,
                    savings: 0,
                    referenceNo: "",
                    otherUnitToPieceQuantity: catalogueItem?.otherUnitToPieceQuantity,
                    caseMrp: catalogueItem?.caseMrp,
                    pieceSize: catalogueItem?.pieceSize,
                    otherUnitMrp: 0,
                    time: "",
                    otherUnitPrice: catalogueItem?.otherUnitPtr,
                    qtyUnit: "",
                    otherUnitQuantity: cartItem?.otherUnitQuantity || 0,
                    mrp: catalogueItem?.mrp,
                    productTag: catalogueItem?.productTag,
                    outletCode: "",
                    caseToPieceQty: catalogueItem?.case2Piece,
                    feature: "",
                    underperformanceAttr: "",
                    searchIndex: catalogueItem?.searchIndex,
                    supplier: catalogueItem?.supplier,
                    actualPtr: 0,
                    isDiscountAvailable: false,
                    tax: 0,
                    pieceToOtherUnitQuantity: 0,
                    otherUnitName: catalogueItem?.otherUnitName,
                    additionalSchemeDescription: "",
                    smartBuy: "",
                    isUpdated: false,
                    subCategory: "",
                    isUOMChanged: false,
                    refId: "",
                    stockQty: 0,
                    groupIdV1: "",
                    maxBenefitStringV1: "",
                    recommendedAttribures: catalogueItem?.recommendedAttributesV2,
                    itemDescV1: "",
                    uom: catalogueItem?.uom,
                    typeV1: "",
                    bandedMaxQuantityV1: 0,
                    minQtyForEarnPoints: 0,
                    recommendationId: catalogueItem?.recommendationId,
                    recommendationPriority: catalogueItem?.recommendationPriority,
                    productCode: catalogueItem?.productCode,
                    productDescription: catalogueItem?.productDescription,
                    creditQty: 0,
                    srp: 0,
                    returnCode: catalogueItem?.returnCode,
                    discountMargin: 0,
                    eb2bCode: catalogueItem?.eb2bCode,
                    secondaryProductTag: catalogueItem?.secondaryProductTag,
                    outOfStock: catalogueItem?.outOfStock,
                    isNotify: catalogueItem?.isNotify,
                    sbu: catalogueItem?.sbu,
                    eanCode: catalogueItem?.eanCode,
                    availableCaseQty:catalogueItem?.availableCaseQty,
                    availablePieceQty:catalogueItem?.availablePieceQty,
                    availableOtherQty:catalogueItem?.availableOtherQty,
                    packPtr:catalogueItem?.packPtr,
                    casePtr:catalogueItem?.casePtr,
                    schemes: catalogueItem?.schemes
                }
                return product;
            });

            for (const cartItem of Object.values(responseCart?.data?.[0]?.data?.[customerID]?.productsMap || {}) as CartProduct[]) {
                const responseSelectedCatalogue = await getDataFromLocalDb('PrimaryCatalogue', { "batchCode": cartItem?.batchCode });
                const catalogueItem = responseSelectedCatalogue?.data?.[0];
                amount = amount + ((cartItem?.pieceQuantity || 0) * catalogueItem?.mrp) + ((cartItem?.caseQuantity || 0) * catalogueItem?.caseMrp);
                quantity = quantity + (cartItem?.pieceQuantity || 0) + (cartItem?.caseQuantity || 0);
            }
            let sortedProductUi = productUi;
            if (reStock && skuCodes && skuCodes.length > 0) {
                sortedProductUi = productUi.sort((a, b) => {
                    const aIsRestock = skuCodes.some((skuCode: string) => 
                        a.batchCode === skuCode || 
                        a.marketSkuCode === skuCode || 
                        catalogue.find(cat => cat.batchCode === a.batchCode)?.skuCode === skuCode
                    );
                    const bIsRestock = skuCodes.some((skuCode: string) => 
                        b.batchCode === skuCode || 
                        b.marketSkuCode === skuCode || 
                        catalogue.find(cat => cat.batchCode === b.batchCode)?.skuCode === skuCode
                    );
                    
                    if (aIsRestock && !bIsRestock) return -1;
                    if (!aIsRestock && bIsRestock) return 1;
                    return 0;
                });
            }

            setTotalAmount(amount);
            setTotalQuantity(quantity);
            setProductUIList(sortedProductUi);
            setProductLoading(false);
        } catch (error) {
            setProductLoading(false);
            console.error(error);
        }
    }


    const [orderUpdateLoading, setOrderUpdateLoading] = useState<boolean>(false);
    const [orderData, setOrderData] = useState<any>({});

    const getOrderDetails = async (orderId: string) => {
        try {
          let res, data
          
              res = await getSinglePrimaryOrder(orderId);
            data = res?.data?.features?.[0]
    
            if (!data) {
              await sendSlackAlert(
                  SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
                  "Missing Order Data in getOrderDetails - CreateNewPrimaryOrder.tsx",
                  `No order data returned for orderId: ${orderId}`,
                  safeStringify({ orderId, response: res })
              );
          }
          const validOrderData = JSON.parse(JSON.stringify(data))
          const validOrderDetails = validOrderData?.orderDetails?.filter((sku: any) => sku?.type !== "freeItem")
          validOrderData.orderDetails = validOrderDetails
    
          if (res.status === 200) {
            const outletCode = data?.outletCode;
            setOrderData(validOrderData);
            await populateCart(validOrderData);
          }
        } catch (error: any) {
          await sendSlackAlert(
                SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
                "Error in populateCart in getOrderDetails - CreateNewPrimaryOrder.tsx",
                `Failed to populate cart for orderId: ${orderId}. Error: ${(error as Error).message}`,
                safeStringify({ error, orderId})
            );
          console.error(Error);
            setGenericModalProps(
              getGenericModalProps("error", `Order with Id ${orderId} not found`)
            );
        }
      };

  const resetCart = async () => {
    const res = await getDataFromLocalDb("Cart");
    const updatedCart = await JSON.parse(JSON.stringify(res?.data?.[0]?.data ?? {}));
    delete updatedCart?.["self"];

    setCart(updatedCart);
    insertDataIntoLocalDB("Cart", [{ id: 1, data: updatedCart }]);
  };
    
    const handleOrderUpdate = async () => {
        setOrderUpdateLoading(true);
        const outletCart = {
          ...cart?.['self'],
          customer: { outletCode: 'self'},
        };
        try {
    
          const products: CartProduct[] = Object.values(outletCart?.productsMap || {});
          let addedSkus: string[] = [];
          const existingBatchCodes = orderData?.orderDetails.map((s: any) => s?.batchCode) ?? [];
    
          addedSkus = products
            .filter((product) => !existingBatchCodes.includes(product.batchCode))
            .map((product) => product.batchCode) ?? [];
    
          let addedCases = 0;
          let addedPieces = 0;
          let addedOtherUnits = 0;
    
          products?.forEach((s: CartProduct) => {
            if (addedSkus?.includes(s?.batchCode)) {
              addedCases += s?.caseQuantity || 0;
              addedPieces += s?.pieceQuantity || 0;
              addedOtherUnits += s?.otherUnitQuantity || 0;
            }
          });
    
        if(isPrimaryOMS) {
          const addMoreProducts: CartProduct[] = Object.values(outletCart?.productsMap || {});
          if(addMoreProducts.length === 0) {
            setGenericModalProps(getGenericModalProps("positive", "Please add items to the cart"));
            return;
          }
          const transformedRows = mergeProductsWithOmsRows(addMorePrimaryOmsRowsData,outletCart?.productsMap,orderData?.siteId,orderData?.supplier,orderData?.warehouseId)
          const requestBody =  prepareSaveChangesReqBody(transformedRows,orderData?.supplier, orderData?.loginId,orderData?.outletCode,orderData?.extendedAttributes?.tlc);
         
          const response = await ChannelkartNetworkPost(
            "/orders/validate?transformerOut=orderDetailSplit",
            requestBody
          );
          if (response?.status === 200 || response?.status === 201) {
            const validateResponse = response?.data?.feature?.[0];
            delete validateResponse["creationTime"];
            const cleanedResponse = transformValidateResponse(validateResponse);
            
            await updateOrder(cleanedResponse, orderData?.orderNumber);
            await resetCart()
            navigate(-1);
          }  else {
            console.error("error");
          }   

        }else {
          const requestBody: Record<any, any> = getValidateRequestBody(outletCart, orderData, undefined,undefined,undefined,state?.arsMap ? true : false) ?? {}
          requestBody.outletCode = orderData?.outletCode;
    
            const response = await ChannelkartNetworkPost(
              "/orders/validate?transformerOut=orderDetailSplit",
              requestBody
            );
            if (response?.status === 200 || response?.status === 201) {
              const validateResponse = response?.data?.feature?.[0];
              delete validateResponse["creationTime"];
              const orderPutPayload = prepareOrderReqBody(validateResponse, OrderType.PRIMARY);
              await updateOrder(orderPutPayload, orderData?.orderNumber);
            
              navigate(-1);
            } else {
              console.error("error");
            }    
          }
        } catch (e) {
          setGenericModalProps(getGenericModalProps("error", "Error while updating order"));
          console.log(e);
        } finally {
          setOrderUpdateLoading(false);
        }
      };

    const cartProducts = cart?.[customerBillingInfo?.outletCode]?.productsMap ?? {};

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      if (
        !loading &&
        !orderUpdateLoading &&
        Object.keys(cart?.[customerBillingInfo?.outletCode]?.productsMap ?? {}).length > 0
      ) {
        orderId ? handleOrderUpdate() : handleCheckout();
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [loading, orderUpdateLoading, cart, customerBillingInfo, orderId, handleCheckout, handleOrderUpdate]);

const toggleShowListView = () => {
        setShowListView((prev) => {
            if (prev) setCurrentPage(1); // Reset page to 1 when switching from list to grid
            return !prev;
        });
    };

    return (
        <div className="secondary_order_container">
            {
                loading ? <Loader sx={{ position: "absolute", top: "45%" }} /> :
                    <>
          <CustomGenericModal
            type={genericModalProps?.type}
            message={genericModalProps?.message}
            modalOpen={genericModalProps?.open}
            onClose={() => {setGenericModalProps(initialGenericModalProps)
              navigateBackOnClose && navigate(-1)
            }}
          />
          
          {orderId && isPrimaryOMS ? (
            <div className="formheaderContainer">
            <FormHeader
              parentLabel={"Edit Order"}
              label="Add More"
              goBackToParent={async () => {
                  await resetCart();
                  navigate(-1);
              }}
            />
          </div>
        ) : null}

                        <div style={{  
                            display: "flex",
                            justifyContent: "space-between"
                            }}>
                            <DefaultHeading heading={`${orderId ? "Select Products" : "Place New Order" } (${totalNumberOfProducts})`}
                                disclaimerText={ConfigDictionary.uomConversionPrimary ? "UOM conversion is enabled, stock will be converted to normalised quantity for ordering." : ""}
                                disclaimerColor="#cc911f"
                                customFontSize={"18px"}
                                primaryPlaceNewOrderText={true}
                                children={
                                     <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <button className="cso_toggle_button" onClick={toggleShowListView}>
                                        {showListView ? <GridViewToggle/> : <ListViewToggle/>}
                                        </button>
                                        <div className="secondary-order-search-bar" style={{width:"240px"}}>
                                            <Search searchFunction={(value) =>
                                                setSearchedValue(value?.toLocaleLowerCase())
                                            } />
                                        </div>
                                    </div>
                                } />
                        </div>

                        
                          <SimpleBar style={{height:"100%", overflowY: "auto", scrollbarWidth: "none"}}>
                            <Grid item xs={12} sx={{
                                height: "100%", display: "flex",
                                flexDirection: "column",
                                flex: "1 1 auto",
                                gap: "10px"
                            }}>
                                <CatalogueFiltersNew
                                  filterOptions={filterOptions}
                                  updateFilterSelection={updateFilterSelection}
                                  selectedFilters={selectedFilters}
                                  filtersConfig={newFiltersConfig}
                                />

                                <Grid item xs={12} className="product-selection-grid" sx={{ flex: "1 1 auto", }}>
                                    {productUIList?.length > 0 ?
                                        <>
                                            <div className="select-product "  
                                            style={
                                               showListView ? {display: "flex", flexDirection: "column"} : ConfigDictionary.otherUnitLabelPrimary
                                                  ? { gridTemplateColumns: "repeat(5, minmax(19%, 1fr))" }
                                                  : {}
                                              }>
                                                {productLoading ? <Loader /> :
                                                    productUIList?.map((productUI: ProductUI) => {
                                                        // Check if this product is a reStock item
                                                        const isRestockItem = reStock && skuCodes && skuCodes.length > 0 && skuCodes.some((skuCode: string) => 
                                                            productUI.batchCode === skuCode || 
                                                            productUI.marketSkuCode === skuCode || 
                                                            catalogue.find(cat => cat.batchCode === productUI.batchCode)?.skuCode === skuCode
                                                        );

                                                        return (
                                                            <CatalogueProductCardPrimary key={productUI?.batchCode} ARSQuantities={state?.arsMap?.[productUI?.batchCode]} productUI={productUI} handleClickViewSkuDetails={handleClickViewSkuDetails}
                                                                updateQuantityInCart={updateQuantityInCart} orderType={OrderType.PRIMARY} customerInfo={{outletCode: "self"}} setCart={setCart} catalogue={catalogue} hideStockQtyTile={Boolean(orderId)} showListView={showListView} isRestockItem={isRestockItem}/>
                                                        );
                                                    })
                                                }
                                            </div>

                                          {!showListView && 
                                            <div style={{
                                                width: "100%", justifyContent: "center", alignItems: "center", display: "flex"
                                            }}>
                                                <Pagination
                                                    count={Math.ceil(totalNumberOfProducts / productsPerPage)}
                                                    page={currentPage}
                                                    onChange={handleChangePage}
                                                    variant="outlined"
                                                    color="primary"
                                                    style={{ margin: '10px' }}
                                                />
                                            </div>
                }  
                                        </>
                                        :
                                        <div style={{ width: "100%", flexDirection:"column",justifyContent: "center", alignItems: "center", display: "flex", height: '100%' }}>
                                              <NoProducts style={{ height: "150px", width: "150px" }} />
                                              <p style={{color: "#484848",     fontSize: "14px", marginTop: "-20px"}}>No products found</p>
                                        </div>
                                    }

                                </Grid >

                                
                            </Grid>
                            </SimpleBar>
                            
                        <CartSummaryFooter
                            isPrimary={true}
                            cartProducts={cartProducts}
                            onButtonClick={orderId ? handleOrderUpdate : handleCheckout}
                            buttonText={orderId ? "Add to Order" : "Proceed To Cart"}
                            endIcon={true}
                            loading={false || orderUpdateLoading}
                            disabled={orderUpdateLoading}
                        />

                        <NewDiscountModalPrimary
                            selectedSkuCode={selectedSku?.batchCode}
                            skuData={getSkuData()}
                            showFooter={false}
                            qtyLabel="In Stock"
                            showMrpAndPackSize={true}
                            createPrimaryOrder = {true}
                    />
                    </>
            }
        </div>
    );
}

export default CreateNewPrimaryOrder;
